import React, { Component } from 'react';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';

import image from '../../assets/img/vector/cloud-backup.svg';
import logo from '../../assets/img/software/acronis.png';
import acronisGif1 from '../../assets/img/contenido/acronis-cyber.gif';
import acronisGif2 from '../../assets/img/contenido/acronis-gif.gif';
import acronis from '../../assets/img/vector/acronis.svg';
import TextImage from '../../subcomponents/TextImage';
import ImageText from '../../subcomponents/ImageText';

import IconBlock from '../../subcomponents/IconBlock28';
import img1 from '../../assets/img/flat/backup1.svg';
import img2 from '../../assets/img/flat/backup2.svg';
import img3 from '../../assets/img/flat/backup3.svg';

class CloudBackup extends Component {
  componentDidMount() {
    document.title = 'Cloud Backup - Insacom';
  }

  render() {
    let iconBlocks = [
      {
        id: 1,
        title: 'Redundancia Geográfica',
        description: 'Tú eliges en que nodos almacenas tus respaldos',
        img: img1
      },
      {
        id: 2,
        title: 'Administración Web',
        description: 'Administra todos tus dispositivos desde un panel web centralizado',
        img: img2
      },
      {
        id: 3,
        title: 'Máxima Performace',
        description: 'Respaldos incrementales para optimizar el uso de tus recursos',
        img: img3
      }
    ];

    return (
      <Section asuntoContacto={'Cloud Backup'}>
        <SectionContainer paddingBottom={50} paddingTop={100}>
          <TextImage
            image={acronisGif2}
            title="Cloud Backup"
            description="Acronis Cyber Backup Cloud protege cualquier entorno virtual, físico y en el cloud con un modelo de negocio de pago por uso.">
            <div className="text-left mt-4">
              <div>
                <img className="g-width-60" src={logo} alt=""></img>
                <img className="g-width-140 ml-4" src={acronis} alt=""></img>
              </div>
            </div>
          </TextImage>
        </SectionContainer>
        <SectionContainer grey>
          <IconBlock version={1} content={iconBlocks}></IconBlock>
        </SectionContainer>
        <SectionContainer>
          <ImageText image={image} title="Proteja cualquier carga de trabajo">
            <div className="row">
              <div className="col-md-6">
                <p className="mb-2">
                  <b>Cloud</b>
                </p>
                <ul className="list-unstyled g-font-size-13 mb-0">
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Máquinas Virtuales en la Cloud
                  </li>
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Office 365
                  </li>
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>G Suite
                  </li>
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Sitios web
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <p className="mb-2">
                  <b>On Premise</b>
                </p>
                <ul className="list-unstyled g-font-size-13 mb-0">
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Físicas
                  </li>
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Virtuales
                  </li>
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Aplicaciones
                  </li>
                  <li>
                    <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                    Entorno Móvil
                  </li>
                </ul>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <div className="text-center g-mb-50">
            <h2 className="h1 g-color-black g-font-weight-600">Acronis Cyber Protect Cloud</h2>
            <p>
              Acronis Cyber Protect Cloud ofrece una integración única de copia de seguridad con
              protección anti-malware de pila completa y última generación y herramientas de gestión
              de punto final integral.
            </p>
          </div>
          <div className="text-center mt-4 g-mb-50">
            <div>
              <img className="img-fluid" src={acronisGif1} alt=""></img>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Copia de seguridad y recuperación</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Recuperación rápida y fiable de sus aplicaciones, sistemas y datos de cualquier
                incidente en cualquier dispositivo
              </p>
            </div>
            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Anti-malware</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Protección de pila completa de última generación contra el malware, además de
                detección de ransomware y criptominería basada en IA
              </p>
            </div>
            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Seguridad y gestión</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Kit de herramientas integral pero sencillo de gestión de puntos finales que ahorra
                recursos de TI
              </p>
            </div>
          </div>
        </SectionContainer>
        <SectionContainer>
          <div className="text-center g-mb-50">
            <h2 className="h1 g-color-black g-font-weight-600">Características esenciales</h2>
          </div>
          <div className="row">
            <div className="col-lg-4  g-brd-around u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">
                    Protección para cualquier carga de trabajo
                  </h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Proteja Windows, Linux, Mac, seis hipervisores principales, iOS, Android,
                aplicaciones Office 365, G Suite.
              </p>
            </div>

            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">
                    Protección contra ransomware basada en IA
                  </h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Defienda los datos, sistemas y copias de seguridad de sus clientes frente al
                ransomware con Acronis Active Protection.
              </p>
            </div>

            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Copias de seguridad rápidas y fiables</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Evite que los archivos de copia de seguridad resulten dañados, reanude y detenga
                trabajos de copia de seguridad en cualquier momento y realice copias de seguridad a
                500 MB/segundo y aún más rápidas.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Acronis Instant Restore</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Recupere sistemas en unos segundos iniciando cualquier sistema directamente desde el
                almacenamiento de copia de seguridad.
              </p>
            </div>

            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Acronis Universal Restore</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Realice la recuperación de hardware distinto espectacularmente más rápido y sin
                problemas de incompatibilidad.
              </p>
            </div>

            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">
                    Recuperación rápida de archivos con autoservicio
                  </h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Ofrezca a los empleados una consola basada en la web para que puedan acceder a las
                copias de seguridad, busquen y restauren archivos desde cualquier lugar.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Envío de datos físicos</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Realice la recopilación inicial más deprisa enviando un disco duro con la copia de
                seguridad completa original a un centro de datos de Insacom.
              </p>
            </div>

            <div className="col-lg-4 u-icon-block--hover g-mb-40">
              <div className="media g-mb-15">
                <div className="media-body align-self-center">
                  <h3 className="h5 g-color-black mb-0">Complemento DRaaS sencillo</h3>
                </div>
              </div>
              <p className="g-color-gray-dark-v4">
                Añada la funcionalidad de recuperación ante desastres al sistema de copia de
                seguridad en solo unos minutos a fin de que puedan acelerar los sistemas en el
                cloud.
              </p>
            </div>
          </div>
        </SectionContainer>
      </Section>
    );
  }
}

export default CloudBackup;



// WEBPACK FOOTER //
// ./src/sections/software/CloudBackup.js